import { bootstrapApplication } from '@angular/platform-browser';
import { initializeSentry } from '@thiememeulenhoff/ng-sdk';
import { setGlobalConfig } from '@thiememeulenhoff/js-sdk';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import '@thiememeulenhoff/albert';
import { environment } from './environments/environment';
import { releaseVersion } from './release-version';

initializeSentry(
  'https://fc46f9a5efe46982890acc1b4d1b31cd@o1127103.ingest.us.sentry.io/4507270370033664',
  {
    enabled: environment.production,
    environment: environment.environment,
    release: releaseVersion(),
    replaysSessionSampleRate: 0,
    unleash: true,
  },
);

setGlobalConfig({
  environment: environment.auth.environment,
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [...appConfig.providers],
}).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
